import AutoContributorLinkHandler from './AllPhotosAccessLinkHandler';

export default AutoContributorLinkHandler;
